import { ArrowBack as CancelIcon, Save as SaveIcon } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { CardActions, CardContent, Grid } from '@mui/material';
import type { FC } from 'react';
import { FormikSwitch } from '../../components/formik-fields/switch.js';
import { CenterCard } from '../../components/page-layout/center-card.js';
import type { EditViewProps } from '../../utils/types.js';
import type { DeviceSettings } from './types.js';

export const EditView: FC<EditViewProps<DeviceSettings>> = ({
  cancel,
  formik,
}) => {
  return (
    <form onReset={formik.handleReset} onSubmit={formik.handleSubmit}>
      <CenterCard>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormikSwitch
                formik={formik}
                id="sharedDevice"
                label="Shared Device"
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions sx={{ justifyContent: 'space-between', pb: 3 }}>
          <LoadingButton
            color="primary"
            loading={formik.isSubmitting}
            onClick={cancel}
            startIcon={<CancelIcon />}
          >
            Cancel
          </LoadingButton>
          <LoadingButton
            color="primary"
            loading={formik.isSubmitting}
            startIcon={<SaveIcon />}
            type="submit"
            variant="contained"
          >
            Save
          </LoadingButton>
        </CardActions>
      </CenterCard>
    </form>
  );
};
